<template>
    <div class="page">
      <!-- 首页内容：只在访问 /bm 时显示 -->
      <template v-if="!isChildRoute">
        <HeaderTop :is_login="false"></HeaderTop>
        <div class="pageContent d-flex d-flex-middle d-flex-center">
          <div class="registration-container">
            <!-- 报名流程部分 -->
            <div class="registration-process-section">
              <div class="section-title">
                <span class="title-bar"></span>
                <h3>报名流程</h3>
              </div>
              <div class="process-image-wrapper">
                <img src="@/assets/login/icon_registration.png" alt="报名流程" class="process-image" />
              </div>
            </div>

            <!-- 考次信息和操作按钮 -->
            <div class="content-bottom">
              <div class="exam-info-section">
                <div class="section-title">
                  <span class="title-bar"></span>
                  <h3>考次信息</h3>
                </div>
                <div class="d-flex d-felx-top d-flex-center">
                  <div class="exam-info-table">
                      <div class="info-row">
                      <div class="info-label">报名批次：</div>
                      <div class="info-value">第{{ examInfo.ndm }}次</div>
                      </div>
                      <div class="info-row">
                      <div class="info-label">缴费时间：</div>
                      <div class="info-value">{{ examInfo.payStatime && examInfo.payEndTime ? `${examInfo.payStatime} 至 ${examInfo.payEndTime}` : '' }}</div>
                      </div>
                      <div class="info-row">
                      <div class="info-label">报名时间：</div>
                      <div class="info-value">{{ examInfo.gatherStatime && examInfo.gatherEndTime ? `${examInfo.gatherStatime} 至 ${examInfo.gatherEndTime}` : '' }}</div>
                      </div>
                      <div class="info-row">
                      <div class="info-label">信息完善时间：</div>
                      <div class="info-value">{{ examInfo.perfectStatime && examInfo.perfectEndTime ? `${examInfo.perfectStatime} 至 ${examInfo.perfectEndTime}` : '' }}</div>
                      </div>
                  </div>
                  <div class="action-buttons-section">
                      <div class="action-titleBox d-flex d-flex-middle d-flex-center">
                        <img src="@/assets/bm/lineL.png" alt="报名流程" class="lineIcon" />
                        <p class="action-title">自学考试新考生报名</p>
                        <img src="@/assets/bm/lineR.png" alt="报名流程" class="lineIcon" />
                      </div>
                      <p class="register-btn" @click="handleRegister">点击报名</p>
                      <p class="query-btn" @click="handleQuery">报名后查询、缴费、信息完善</p>
                  </div>
                </div>
                
              </div>

              
            </div>
          </div>
        </div>
        <Footer></Footer>
      </template>
      
      <!-- 登录弹窗 -->
      <div v-if="showLoginDialog" class="login-dialog-overlay">
          <i class="el-icon-close login-dialog-close" @click.self="closeLoginDialog"></i>
          <LoginBox @success="handleLoginSuccess" />
      </div>
      
      <!-- 子路由视图 -->
      <router-view></router-view>
    </div>
  </template>
  
  <script>
  import HeaderTop from "@/components/HeaderTop.vue";
  import Footer from "@/components/Footer.vue";
  import LoginBox from "@/components/LoginBox.vue";
  import { mapState } from "vuex"
  export default {
    components: {
      HeaderTop,
      Footer,
      LoginBox
    },
    data() {
      return {
        MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
        examInfo: {},
        showLoginDialog: false
      };
    },
    computed: {
      ...mapState(['tenantInfo']),
      // 判断是否在子路由中
      isChildRoute() {
        const childRouteNames = [
          'BmStepNotice',
          'BmStepSelectLocation',
          'BmStepSelectMajor',
          'BmStepRegisterInfo',
          'BmStepSubmitRegistration',
          'BmStepPayment'
        ];
        return childRouteNames.includes(this.$route.name);
      }
    },
    mounted() {
      this.getExamConfigInfo()
    },
    methods: {
      handleRegister() {
        this.$router.push({ name: 'BmStepNotice' })
      },
      handleQuery() {
        this.showLoginDialog = true;
      },
      closeLoginDialog() {
        this.showLoginDialog = false;
      },
      handleLoginSuccess() {
        this.closeLoginDialog();
        this.$router.push({ path: "/main/bmRegister" });
      },
      getExamConfigInfo() {
        this.$http.get(this.MOCK_PREFIX+'/student/pc/getExamConfigInfo',{ current: 1, size: 6 }).then(res => {
          if (res) {
            this.examInfo = res;
          }
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .page {
    min-height: 100vh;
    position: relative;
  }

  .pageContent {
    padding: 20px;
    min-height: calc(100vh - 200px);
    margin-top: 70px;
    background: url('../../assets/bm/bmBg.png') no-repeat center center;
    background-size: 100% 100%;
  }

  .registration-container {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    padding: 35px 75px;
  }

  .registration-process-section {
    margin-bottom: 30px;
  }

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;

    .title-bar {
      width: 4px;
      height: 20px;
      background: #1890ff;
      margin-right: 10px;
      border-radius: 2px;
    }

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  .process-image-wrapper {
    width: 100%;
    text-align: center;
    margin: 20px 0;

    .process-image {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }

  .content-bottom {
    display: flex;
    gap: 30px;
    margin-top: 30px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .exam-info-section {
    flex: 1;
  }

  .exam-info-table {
    padding: 20px;
    margin-top: 15px;
    width: 520px;
    background: #EEF6FE;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #B0D2EC;
    margin-right: 120px;

    .info-row {
      display: flex;
      padding: 12px 0;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }

      .info-label {
        min-width: 120px;
        font-weight: 500;
        color: #767676;
        font-size: 14px;
      }

      .info-value {
        flex: 1;
        color: #1A1A1A;
        font-size: 14px;
      }
    }
  }

  .action-buttons-section {
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: 768px) {
      width: 100%;
    }
    .action-titleBox{
      width: 100%;
      margin-bottom: 20px;
    }

    .action-title {
      font-weight: 700;
      font-size: 20px;
      color: #1A1A1A;
      margin: 0 10px;
    }

    .register-btn,
    .query-btn {
      width: 330px;
      height: 50px;
      line-height: 50px;
      border-radius: 10px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;
      text-align: center;
      margin: 30px auto 0 auto;
    }

    .register-btn {
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
      color: #fff;
    }

    .query-btn {
        background: linear-gradient( 180deg, #FF8F1F 0%, #FFAA56 100%);
      color: #fff;
    }
  }

  .login-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  .login-dialog-close {
    font-size: 28px;
    color: #1687DE;
    cursor: pointer;
    line-height: 1;
    transition: color 0.3s;
    position: absolute;
    right: 20px;
    top: 20px;
    &:hover {
      color: #fff;
    }
  }
  </style>
  